import axios from 'axios'

const state = {
  items: [],
  previewOpen: false,
  loaded: false,
  itemCount: 0,
  updatingItems: {},
}

const getters = {
  subtotal(state) {
    let subtotal = 0
    state.items.forEach(i => subtotal += i.final_line_price )
    return subtotal
  }
}

const mutations = {
  addItems(state, items) {
    let existingItem = null
    items.forEach(item => {
      existingItem = state.items.find(i => i.id == item.id)
      if (existingItem) {
        existingItem.quantity = item.quantity
      } else {
        state.items.push(item)
      }
    })
  },
  setItemCount(state, payload) {
    state.itemCount = payload
  },
  setItems(state, payload) {
    state.items = payload
  },
  setLoaded(state, payload) {
    state.loaded = payload
  },
  setItemUpdating(state, { itemKey, updating }) {
    state.updatingItems = {
      ...state.updatingItems,
      [itemKey]: updating,
    }
  },
  openPreview(state) {
    state.previewOpen = true
  },
  closePreview(state) {
    state.previewOpen = false
  }
}

const actions = {
  async addItemsToCart({ dispatch, commit }, items) {
    let formattedData = { items: [] }
    if (Array.isArray(items)) {
      formattedData.items = items.map(item => {
        let formattedItem = { id: parseInt(item.id), quantity: item.quantity }
        if (item.properties) {
          formattedItem.properties = item.properties
        }
        return formattedItem
      })
    } else {
      for (let [itemId, quantity] of Object.entries(items)) {
        itemId = parseInt(itemId)
        formattedData.items.push({ id: itemId, quantity: quantity })
      }
    }
    return axios.post('/cart/add.js', formattedData
    ).then(response => {
      commit('addItems', response.data.items) // Add the item quickly
      dispatch('loadCart') // Then check for updates in case we are missing anything
    })
  },
  async loadCart({ commit }) {
    axios({
      method: "get",
      url: "/cart.js",
    }).then((response) => {
      commit('setItems', response.data.items)
      commit('setItemCount', response.data.item_count)
      commit('setLoaded', true)
    });
  },

  async changeItemQuantity({ commit, dispatch }, { item, quantity }) {
    const itemKey = item.key || item.id
    commit('setItemUpdating', { itemKey, updating: true })

    return axios.post('/cart/change.js', {
      id: itemKey,
      quantity,
    }).then((response) => {
      commit('setItems', response.data.items)
      commit('setItemCount', response.data.item_count)
    }).catch(error => {
      dispatch('loadCart')
      throw error
    }).finally(() => {
      commit('setItemUpdating', { itemKey, updating: false })
    })
  },

  async removeItem({ dispatch }, item) {
    return dispatch('changeItemQuantity', { item, quantity: 0 })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}